<template>
    <div id="app" :class="{'sf-mode' : sfMode, 'cursor-progress' : isLoading}">
        <Header v-if="!sfMode"/>
        <Menu v-if="!sfMode"/>
        <router-view v-if="loaded"/>
        <Footer v-if="!sfMode && loaded"/>
        <LoadingScreen />
        <Modal />
        <MessageBox />
        <Alert />
        <FatalErrorOverlay />
    </div>
</template>

<script>
    import Header from './components/vue-components/src/components/app/header/Header';
    import Footer from './components/vue-components/src/components/app/footer/Footer';
    import Menu from './components/vue-components/src/components/app/menu/Menu';
    import LoadingScreen from './components/vue-components/src/components/core/overlays/LoadingScreen';
    import Modal from './components/vue-components/src/components/core/overlays/Modal';
    import MessageBox from './components/vue-components/src/components/core/overlays/MessageBox';
    import Alert from './components/vue-components/src/components/core/overlays/Alert';
    import FatalErrorOverlay from './components/vue-components/src/components/core/overlays/error/FatalErrorOverlay';
    import {setAuth, setCorsHeaders} from './apis/sthree.consultant.api';

    import 'whatwg-fetch';
    import cssVars from 'css-vars-ponyfill';


    export default {
        async created() {
            var isSf = (this.$route.path.indexOf('/Consultant') > -1) && !(this.$route.path.indexOf('localhost') > -1);
            this.$store.dispatch('setSfMode', isSf);
            let urlParams = this.$route.path.split('/').slice(1);   
            const isSalesforce = this.$route.path.indexOf('/Consultant') > -1;        
            let user = urlParams.length > 0 ? (isSalesforce ? urlParams[1] : urlParams[0]) : null;
            let token = urlParams.length > 0 ? (isSalesforce ? urlParams[2] : urlParams[1]) : null;
            
            this.$store.dispatch('setUserId', user);
            this.$store.dispatch('setTheme', this.theme);
            this.$store.dispatch('startFetch');
            console.log("user:"+ user);
            await setAuth(token, user);
            await setCorsHeaders();
            await this.fetchSalesforceInfo()
            .catch((error) => {
                if (error.responseStatus) {
                    this.$store.dispatch('throwErrorFatal', error.responseStatus.message);
                } else {
                    this.$store.dispatch('throwErrorFatal', error);
                }
            });

            await Promise.all([
                this.fetchSalesforceInfo(),
                this.fetchLanguages(),
                this.fetchCountries(),
                this.fetchCvSources(),
                this.fetchBrands(),
                this.fetchSalutations(),
                this.fetchEmploymentTypes()
            ])
            .then(() => {
                this.loaded = true;
            })
            .catch((error) => {
                this.loaded = true;
                if (error.responseStatus) {
                    this.$store.dispatch('throwErrorFatal', error.responseStatus.message);
                } else {
                    this.$store.dispatch('throwErrorFatal', error);
                }
            });

            this.$store.dispatch('endFetch');

            cssVars();

        },
        components: {Menu, Header, Footer, LoadingScreen, Modal, MessageBox, Alert, FatalErrorOverlay},
         data() {
            return {
                loaded: false
            };
        },
        computed: {
            user() {
                return this.$route.params.user || null;
            },
            theme() {
                return this.$route.query.theme || null;
            },
            token() {
                return this.$route.params.token || null;
            },
            sfMode() {
                return this.$store.state.app.sfMode;
            },
            isOccupied() {
                return this.$store.state.activity.fetching || this.$store.state.activity.uploading
            },
            isLoading() {
                return this.$store.state.activity.loading
            }
        },
        methods: {
            async fetchSalesforceInfo() {
                return this.$store.dispatch('getSalesforceInfo');
            },
            async fetchCountries() {
                return this.$store.dispatch('lookup', {type: 'Country'});
            },
            async fetchSalutations() {
                return this.$store.dispatch('lookup', {type: 'Salutation'});
            },
            async fetchLanguages() {
                return this.$store.dispatch('lookup', {type: 'SpokenLanguage'});
            },
            async fetchCvSources() {
                return this.$store.dispatch('lookup', {type: 'CvSources'});
            },
            async fetchBrands() {
                return this.$store.dispatch('lookup', {type: 'Brand', userId: this.$store.state.user.id});
            },
            async fetchEmploymentTypes() {
                return this.$store.dispatch('lookup', {type: 'EmploymentType'});
            }
        }
    }
</script>

<style>
    @import 'https://fonts.googleapis.com/css?family=Roboto|Roboto+Condensed';
    @import 'https://use.typekit.net/vrd1pdo.css';

    @import './components/vue-components/public/css/grid.css';
    @import './components/vue-components/public/css/base.css';
    @import './assets/css/main.css';
</style>

